import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from '../../moduleBreadcrumbs';

export default [
  ...buildCrudRoutes({
    baseName: 'privacyPolicy',
    basePath: 'privacy-policy',
    baseBreadcrumbs: [
      ...moduleBreadcrumbs,
    ],
    card: {
      title: 'Políticas de privacidade',
      icon: '',
    },
    moduleActive: 'contacard',
    subModuleActive: 'legalAgreements',
    listRoute: {
      pageContent: () => import('Modules/contacard/legalAgreements/PrivacyPolicy/PrivacyPolicyList.vue'),
      reportComponent: () => import('Modules/contacard/legalAgreements/PrivacyPolicy/PrivacyPolicyLatestDownload.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar política', searchAttribute: 'search' },
      pageTitle: 'Políticas de privacidade',
      navigateBackRoute: 'contacard.submodules.list',
      btnText: 'Adicionar política',
      newRouteName: 'privacyPolicy.new',
    },
    newRoute: {
      component: () => import('Modules/contacard/legalAgreements/PrivacyPolicy/PrivacyPolicyForm.vue'),
      breadcrumbs: [
        {
          text: 'Criar política de privacidade',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('Modules/contacard/legalAgreements/PrivacyPolicy/PrivacyPolicyForm.vue'),
      breadcrumbs: [
        {
          text: 'Visualizar política de privacidade',
          disabled: true,
        },
      ],
    },
  }),
];
